import ChecklistItem, {
  DocumentRequirement,
  InfoItem,
} from "models/checklist/checklist-item/checklist-item";
import ChecklistItemStatus from "../../../../../models/checklist/checklist-item/checklist-item-status";

export const cardHasButton = (
  item: ChecklistItem,
  status: ChecklistItemStatus
): boolean => {
  const statusesWithButton: Array<ChecklistItemStatus> = [
    ChecklistItemStatus.VerificationRequired,
    ChecklistItemStatus.NotYetResolved,
  ];

  // show buttons when eligible status, and
  // a) item is DocumentRequirement,
  // or b) item is InfoItem and has either externalLink or description
  return (
    statusesWithButton.includes(status) &&
    (item instanceof DocumentRequirement ||
      (item instanceof InfoItem &&
        (item.externalLink !== undefined || item.description !== undefined)))
  );
};
